"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _react = _interopRequireDefault(require("react"));

var _field = _interopRequireDefault(require("./field"));

var _attach = _interopRequireDefault(require("../attach"));

var _helpToolTip = _interopRequireDefault(require("./help-tool-tip"));

var _flexBreak = _interopRequireDefault(require("../flex-break"));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var CompositeField = /*#__PURE__*/function (_React$PureComponent) {
  (0, _inherits2.default)(CompositeField, _React$PureComponent);

  var _super = _createSuper(CompositeField);

  function CompositeField() {
    (0, _classCallCheck2.default)(this, CompositeField);
    return _super.apply(this, arguments);
  }

  (0, _createClass2.default)(CompositeField, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          component = _this$props.component,
          help = _this$props.help,
          editable = _this$props.editable,
          useDisplayValue = _this$props.useDisplayValue,
          block = _this$props.block,
          disabled = _this$props.disabled;
      var fields = [];
      var lastIsBlock = false;
      var first = true;
      component.eachField(function (field, index, last) {
        // Don't show the field if we are using the display value and it is blank, e.g. it is the
        // empty "next" field.
        if (first || !useDisplayValue || !field.isBlank()) {
          if (last && field.get('block')) {
            lastIsBlock = true;
          }

          fields.push( /*#__PURE__*/_react.default.createElement(_field.default, {
            component: field,
            key: index,
            noBlock: last,
            disabled: disabled
          }));
        }

        if (first) {
          first = false;
        }
      });

      if (help && editable) {
        fields.push( /*#__PURE__*/_react.default.createElement(_helpToolTip.default, {
          help: help,
          key: "help"
        }));
      }

      if (lastIsBlock && block !== false) {
        // Break after any help
        fields.push( /*#__PURE__*/_react.default.createElement(_flexBreak.default, {
          key: "break"
        }));
      }

      return fields;
    }
  }]);
  return CompositeField;
}(_react.default.PureComponent); // We want the component to update when we receive new fields


var _default = (0, _attach.default)(['change', 'help', 'editable', 'useDisplayValue'])(CompositeField);

exports.default = _default;